import UserAdmin from "pages/Admin/UserAdmin";

export default function UserAdminPage() {
  return <UserAdmin />;
}
